var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 187,
    viewBox: "0 0 179 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5714 130.131C129.833 130.131 162.471 142.849 162.471 158.538C162.471 174.227 129.833 186.945 89.5714 186.945C49.3101 186.945 16.6719 174.227 16.6719 158.538C16.6719 142.849 49.3101 130.131 89.5714 130.131ZM89.5714 176.188C114.586 176.188 134.865 168.286 134.865 158.538C134.865 148.79 114.586 140.888 89.5714 140.888C64.5564 140.888 44.2777 148.79 44.2777 158.538C44.2777 168.286 64.5564 176.188 89.5714 176.188Z",
    fill: "url(#paint0_linear_5131_565380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.569 88.9994L20.1992 48.9491L89.5669 8.89941L158.937 48.9501L89.569 88.9994Z",
    fill: "#FF5A0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8072 69.5074L53.9609 68.4415L123.328 28.3918L125.174 29.4574L55.8072 69.5074Z",
    fill: "#BF3C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.7565 72.3657L49.0078 65.5825L118.375 25.5332L130.124 32.3164L60.7565 72.3657Z",
    fill: "#FFBD9F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5694 169.099L20.1992 129.048V48.9497L89.5694 89.0001V169.099Z",
    fill: "#FF5A0F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.939 129.048L89.5703 169.099V89.0001L158.939 48.9497V129.048Z",
    fill: "#BF3C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.097 153.735C100.069 153.425 99.8263 153.308 99.5351 153.477C99.356 153.58 99.1965 153.768 99.0929 153.978C99.0306 154.104 98.9096 154.174 98.8473 154.119C98.744 154.029 98.5845 154.025 98.4058 154.128C98.2268 154.232 98.0673 154.42 97.9637 154.63C97.9014 154.756 97.7803 154.826 97.7187 154.771C97.6151 154.681 97.456 154.677 97.2769 154.78C97.0979 154.884 96.9384 155.072 96.8351 155.282C96.7725 155.408 96.6518 155.477 96.5899 155.423C96.4863 155.333 96.3271 155.329 96.1481 155.433C95.8565 155.601 95.6148 155.996 95.5859 156.34C95.6169 154.915 96.6148 153.207 97.8416 152.499C99.0683 151.79 100.066 152.346 100.097 153.735Z",
    fill: "#FFBD9F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4037 157.995C97.9505 158.256 97.582 158.043 97.582 157.52V153.952L98.0975 153.654V157.222C98.0975 157.417 98.2349 157.497 98.4037 157.399C98.5721 157.301 98.7095 157.063 98.7095 156.869L99.2253 156.571C99.2253 157.095 98.8565 157.733 98.4037 157.995Z",
    fill: "#FFBD9F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.343 157.989L95.3387 160.879C94.7966 161.192 94.3555 160.937 94.3555 160.311V154.533C94.3555 153.907 94.7966 153.143 95.3387 152.83L100.343 149.941C100.885 149.628 101.326 149.882 101.326 150.508V156.286C101.326 156.912 100.885 157.676 100.343 157.989ZM95.3387 153.396C95.0664 153.552 94.8453 153.936 94.8453 154.25V160.028C94.8453 160.342 95.0664 160.47 95.3387 160.313L100.343 157.424C100.615 157.267 100.836 156.884 100.836 156.569V150.791C100.836 150.477 100.614 150.35 100.343 150.506L95.3387 153.396Z",
    fill: "#FFBD9F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.862 149.055C105.79 149.019 105.674 149.089 105.604 149.21L105.137 150.015L104.41 149.592C105.078 148.528 105.797 149.009 105.862 149.055Z",
    fill: "#FFBD9F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.055 148.059L106.326 149.323L105.867 149.058C105.867 149.058 105.864 149.056 105.862 149.055C105.797 149.009 105.078 148.528 104.41 149.592L104.874 148.788C105.349 147.967 106.122 147.52 106.596 147.794L107.055 148.059Z",
    fill: "#FFBD9F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.399 149.01L105.949 149.847L107.399 147.336V149.01Z",
    fill: "#FFBD9F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.245 152.248C104.223 152.372 104.283 152.452 104.379 152.426L105.014 152.258L104.746 153.562C103.903 153.72 104.215 152.372 104.245 152.248Z",
    fill: "#FFBD9F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.42 151.685L104.417 151.419L104.249 152.239C104.249 152.239 104.248 152.244 104.247 152.248C104.217 152.372 103.904 153.72 104.747 153.561L104.113 153.732C103.466 153.905 103.079 153.355 103.252 152.507L103.42 151.685Z",
    fill: "#FFBD9F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.111 150.368L104.836 151.399L102.855 151.93L104.111 150.368Z",
    fill: "#FFBD9F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.751 151.286C106.846 151.198 106.901 151.048 106.876 150.954L106.707 150.317L107.702 149.436C107.877 150.342 106.846 151.209 106.751 151.286Z",
    fill: "#FFBD9F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.384 152.845L106.117 151.848L106.744 151.293C106.744 151.293 106.748 151.29 106.751 151.286C106.846 151.209 107.878 150.342 107.702 149.436L107.873 150.07C108.046 150.718 107.659 151.715 107.011 152.289L106.384 152.845Z",
    fill: "#FFBD9F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.352 153.211L106.076 151.343L106.607 153.323L105.352 153.211Z",
    fill: "#FFBD9F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.885 153.636L102.881 156.524C102.339 156.837 101.898 156.583 101.898 155.957V150.179C101.898 149.553 102.339 148.789 102.881 148.476L107.885 145.587C108.427 145.274 108.869 145.528 108.869 146.155V151.932C108.869 152.559 108.427 153.323 107.885 153.636ZM102.881 149.042C102.609 149.199 102.388 149.582 102.388 149.896V155.674C102.388 155.988 102.61 156.116 102.881 155.959L107.885 153.07C108.158 152.914 108.378 152.53 108.378 152.216V146.438C108.378 146.124 108.157 145.996 107.885 146.153L102.881 149.042Z",
    fill: "#FFBD9F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.885 149.347L111.16 149.765V146.031L111.885 145.613V149.347Z",
    fill: "#FFBD9F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.072 147.506V148.343L110.57 150.942V150.106L115.072 147.506Z",
    fill: "#FFBD9F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.486 147.847L113.762 148.265V144.531L114.486 144.112V147.847Z",
    fill: "#FFBD9F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.711 145.316L110.336 146.687L111.523 144.63L112.711 145.316Z",
    fill: "#FFBD9F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M115.308 143.816L112.934 145.187L114.121 143.13L115.308 143.816Z",
    fill: "#FFBD9F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.323 149.341L110.319 152.23C109.777 152.543 109.336 152.289 109.336 151.663V145.885C109.336 145.259 109.777 144.495 110.319 144.182L115.323 141.293C115.865 140.98 116.306 141.234 116.306 141.86V147.638C116.306 148.264 115.865 149.028 115.323 149.341ZM110.319 144.748C110.047 144.905 109.826 145.288 109.826 145.602V151.38C109.826 151.694 110.047 151.822 110.319 151.665L115.323 148.776C115.595 148.619 115.816 148.235 115.816 147.921V142.143C115.816 141.829 115.595 141.702 115.323 141.859L110.319 144.748Z",
    fill: "#FFBD9F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.448 142.39C121.427 141.654 122.19 139.758 122.19 138.6L118.324 140.833C118.324 141.991 119.089 143.005 120.067 142.611V144.95L119.059 145.532V145.909L121.455 144.526V144.149L120.448 144.73V142.39H120.448Z",
    fill: "#FFBD9F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.761 145.047L117.757 147.936C117.215 148.249 116.773 147.995 116.773 147.369V141.591C116.773 140.965 117.215 140.201 117.757 139.887L122.761 136.998C123.302 136.686 123.744 136.94 123.744 137.566V143.344C123.744 143.97 123.302 144.734 122.761 145.047ZM117.757 140.453C117.485 140.61 117.263 140.994 117.263 141.308V147.085C117.263 147.4 117.485 147.528 117.757 147.371L122.761 144.481C123.033 144.325 123.254 143.941 123.254 143.627V137.849C123.254 137.535 123.033 137.407 122.761 137.564L117.757 140.453Z",
    fill: "#FFBD9F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M153.487 69.13L136.291 79.0585C135.493 79.5195 134.844 79.1443 134.844 78.2226V69.716C134.844 68.7947 135.493 67.6697 136.291 67.2091L153.487 57.2809C154.286 56.8199 154.935 57.1951 154.935 58.1161V66.6231C154.936 67.5444 154.286 68.6694 153.487 69.13ZM136.291 68.0417C135.891 68.2731 135.565 68.837 135.565 69.2995V77.8061C135.565 78.2689 135.891 78.4569 136.291 78.2251L153.488 68.297C153.889 68.0659 154.214 67.5017 154.214 67.0396V58.5326C154.214 58.0702 153.889 57.8822 153.488 58.1136L136.291 68.0417Z",
    fill: "#FFBD9F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.617 76.3921L136.707 76.9175V68.8694L137.617 68.344V76.3921Z",
    fill: "#FFBD9F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.769 69.9532L147.859 70.478V62.4302L148.769 61.9048V69.9532Z",
    fill: "#FFBD9F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M139.389 75.3707L138.074 76.1297V68.0816L139.389 67.3223V75.3707Z",
    fill: "#FFBD9F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M147.455 70.7126L146.141 71.4716V63.4235L147.455 62.6646V70.7126Z",
    fill: "#FFBD9F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M151.969 68.1073L151.059 68.6328V60.585L151.969 60.0596V68.1073Z",
    fill: "#FFBD9F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150.65 68.8673L149.336 69.6267V61.5782L150.65 60.8196V68.8673Z",
    fill: "#FFBD9F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M144.495 72.422L142.523 73.5609V65.5128L144.495 64.3743V72.422Z",
    fill: "#FFBD9F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M140.65 74.6405L139.992 75.0204V66.9719L140.65 66.5928V74.6405Z",
    fill: "#FFBD9F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M153.071 67.4697L152.414 67.8492V59.8015L153.071 59.4216V67.4697Z",
    fill: "#FFBD9F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.915 73.9112L141.258 74.2907V66.2423L141.915 65.8628V73.9112Z",
    fill: "#FFBD9F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M145.716 71.7169L145.059 72.096V64.0483L145.716 63.6685V71.7169Z",
    fill: "#FFBD9F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3633 60.0134L90.2097 87.8914H88.9302L139.384 60.2395L90.2101 90.1082L89.5703 90.497L88.9295 90.1082L39.3633 60.0134Z",
    fill: "#BF3C00"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.6205 72.0799V80.5014L59.1349 81.2821L57.6721 78.7994L56.1869 79.5801L54.7237 77.097L53.2602 77.8905L51.7974 75.4077L50.3343 76.2013L48.8711 73.7178V65.2966L60.6205 72.0799Z",
    fill: "#FFBD9F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8631 110.814L27.5439 78.7136L26.5117 79.3126L81.8307 111.413L82.8631 110.814Z",
    fill: "#333333"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8644 151.461V110.811L81.832 111.41V152.06L82.8644 151.461Z",
    fill: "#4C4C4C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8309 152.06L26.5117 119.96V79.3093L81.8309 111.41V152.06Z",
    fill: "#4C4C4C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9874 111.995V150.498L27.3555 119.377V80.8738L80.9874 111.995Z",
    fill: "#4C4C4C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8124 86.2934C30.8124 86.7454 30.4967 86.9284 30.1074 86.7026C29.718 86.4766 29.4023 85.9272 29.4023 85.4752C29.4023 85.0233 29.718 84.84 30.1074 85.066C30.4966 85.292 30.8124 85.8414 30.8124 86.2934Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3789 88.0203L35.8388 90.0282V88.3916L32.3789 86.3838V88.0203Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9336 91.8236L42.3937 93.8312V92.1948L38.9336 90.187V91.8236Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4883 95.6274L48.9484 97.6352V95.9986L45.4883 93.991V95.6274Z",
    fill: "#FFCFE0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M52.043 99.4308L55.5031 101.438V99.802L52.043 97.7942V99.4308Z",
    fill: "#FFCFE0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5977 103.235L62.0576 105.242V103.606L58.5977 101.598V103.235Z",
    fill: "#FFCFE0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7992 119.414L65.571 111.738C65.1046 111.468 64.7266 110.742 64.7266 110.116V106.584C64.7266 105.959 65.1046 105.672 65.571 105.943L78.7992 113.619C79.2656 113.889 79.6437 114.615 79.6437 115.24V118.772C79.6439 119.397 79.2657 119.685 78.7992 119.414Z",
    fill: "#FFCFE0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M77.621 117.105L66.7461 110.794V108.252L77.621 114.563V117.105Z",
    fill: "#4C4C4C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1033 120.987L29.4023 108.975V93.4512L50.1033 105.463V120.987Z",
    fill: "#FFCFE0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1032 122.888L29.4023 110.876V108.974L50.1032 120.986V122.888Z",
    fill: "#FFCFE0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8586 108.441L37.6445 108.323V103.669L41.8586 108.441Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M60.595 128.954L52.9766 124.504L53.026 107.104L60.6445 111.554L60.595 128.954Z",
    fill: "#FFCFE0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1066 134.511L62.4883 130.061L62.5376 112.661L70.156 117.111L70.1066 134.511Z",
    fill: "#FFCFE0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6222 140.067L72.0039 135.618L72.0532 118.218L79.6717 122.668L79.6222 140.067Z",
    fill: "#8A8A8A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5798 121.626L30.0725 118.43C29.7025 118.215 29.4023 117.639 29.4023 117.143V114.082C29.4023 113.586 29.7025 113.359 30.0725 113.573L35.5798 116.769C35.9499 116.984 36.25 117.56 36.25 118.056V121.117C36.25 121.613 35.9499 121.841 35.5798 121.626Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2595 126.661L38.7522 123.466C38.3822 123.251 38.082 122.675 38.082 122.179V119.118C38.082 118.622 38.382 118.394 38.7522 118.609L44.2595 121.804C44.6295 122.019 44.9297 122.595 44.9297 123.091V126.152C44.9297 126.648 44.6295 126.876 44.2595 126.661Z",
    fill: "#FFCFE0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9392 131.698L47.4319 128.502C47.0618 128.287 46.7617 127.711 46.7617 127.215V124.154C46.7617 123.658 47.0617 123.43 47.4319 123.645L52.9392 126.841C53.3092 127.055 53.6094 127.632 53.6094 128.128V131.189C53.6094 131.685 53.3092 131.912 52.9392 131.698Z",
    fill: "#8A8A8A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6149 136.734L56.1077 133.538C55.7376 133.324 55.4375 132.748 55.4375 132.251V129.19C55.4375 128.694 55.7376 128.466 56.1077 128.681L61.6149 131.877C61.985 132.092 62.285 132.668 62.285 133.164V136.225C62.285 136.721 61.985 136.949 61.6149 136.734Z",
    fill: "#FFCFE0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2944 141.77L64.7872 138.575C64.4171 138.36 64.1172 137.784 64.1172 137.288V134.227C64.1172 133.731 64.4171 133.503 64.7872 133.718L70.2944 136.913C70.6645 137.128 70.9645 137.704 70.9645 138.2V141.261C70.9645 141.757 70.6645 141.985 70.2944 141.77Z",
    fill: "#8A8A8A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9743 146.807L73.4671 143.611C73.097 143.396 72.7969 142.82 72.7969 142.324V139.263C72.7969 138.767 73.097 138.539 73.4671 138.754L78.9743 141.95C79.3444 142.165 79.6445 142.741 79.6445 143.237V146.298C79.6445 146.794 79.3444 147.021 78.9743 146.807Z",
    fill: "#FFCFE0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5933 124.56L39.4141 122.135V120.711L43.5933 123.136V124.56Z",
    fill: "#4C4C4C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1937 127.097C49.1937 127.482 48.9248 127.638 48.593 127.446C48.2611 127.253 47.9922 126.785 47.9922 126.4C47.9922 126.015 48.2611 125.859 48.593 126.051C48.9248 126.244 49.1937 126.712 49.1937 127.097Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7834 128.02C50.7834 128.405 50.5145 128.561 50.1828 128.369C49.851 128.176 49.582 127.708 49.582 127.323C49.582 126.938 49.851 126.782 50.1828 126.975C50.5145 127.167 50.7834 127.635 50.7834 128.02Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3732 128.942C52.3732 129.327 52.1043 129.483 51.7726 129.291C51.4408 129.098 51.1719 128.63 51.1719 128.245C51.1719 127.86 51.4408 127.704 51.7726 127.897C52.1043 128.089 52.3732 128.557 52.3732 128.942Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1838 139.519L66.8975 138.773C66.5851 138.592 66.332 138.105 66.332 137.687V136.397C66.332 135.978 66.5851 135.786 66.8975 135.967L68.1838 136.714C68.4962 136.895 68.7493 137.381 68.7493 137.8V139.09C68.7493 139.508 68.4962 139.7 68.1838 139.519Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7653 108.386L41.5875 127.637L27.4219 119.417L60.5996 100.166L74.7653 108.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9839 114.441V119.871L54.5929 135.184L49.9141 132.469L80.9839 114.441Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5131_565380",
    x1: 89.5714,
    y1: 186.945,
    x2: 89.5714,
    y2: 130.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.f892d8b852ebd16b8af12b2f9eb866fc.svg";
export { ForwardRef as ReactComponent };